import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StatusCalculationComponent } from './status-calculation.component';

const routes: Routes = [
  {
    path: '',
    component: StatusCalculationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StatusCalculationRoutingModule { }
